import React, { FormEvent, useEffect, useState } from "react";
import useAuthData from "../../hook/useAppData";
import { getCorporationData, updateCorporation } from "./service";
import { ICorporation } from "./model";
import Spinner from "../../components/Spinner";
import "./index.scss";
import Input from "../../components/Input";
import { remask } from "../../libs/remask-mask";
import { getCEP } from "../../libs/getAddresByCep/getAddresByCep";
import { toastError, toastSuccess } from "../../components/Toast";
import { Toaster } from "react-hot-toast";

export function Corporation() {
  const { token } = useAuthData();
  const [corporation, setCorporation] = useState<ICorporation>();
  const [needSpinner, setNeedSpinner] = useState<boolean>(true);

  useEffect(() => {
    getCorporation();
  }, []);

  async function getCorporation() {
    const resGet = await getCorporationData(token);
    setCorporation(resGet);
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }

  function updateValue({ name, value }: { name: string; value: any }) {
    setCorporation({
      ...corporation,
      corporateInvoiceData: {
        ...corporation?.corporateInvoiceData,
        [`${name}`]: value,
      },
    });
  }

  async function getCEPAndUpdateValue(value) {
    const res = await getCEP(value, token);
    const cepData: ICorporation["corporateInvoiceData"] = {
      ...corporation.corporateInvoiceData,
      city: res?.city,
      state: res?.state,
      street: res?.street,
      zipCode: value,
    };
    setCorporation({ ...corporation, corporateInvoiceData: cepData });
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const resPut = await updateCorporation({ body: corporation, token });
    if (!resPut?.ok) toastError("Não foi possível alterar os dados da empresa");
    toastSuccess("Dados alterados com sucesso");
  }

  return (
    <>
      <Toaster toastOptions={{ duration: 4000 }} />
      <Spinner status={needSpinner}>
        <form onSubmit={handleSubmit} className="corporation container">
          <div className="form-box-title title-form">
            <h1>{corporation?.name}</h1>
          </div>
          <div className="box-form between">
            <div className="corporation-form">
              <div className="box-row">
                <Input
                  value={corporation?.name}
                  setValue={(e) => {
                    setCorporation({
                      ...corporation,
                      name: e.target.value,
                    });
                  }}
                  name="name"
                  label="Nome da Empresa"
                  placeholder="Nome da Empresa"
                  autofocus
                />
                <Input
                  value={corporation?.corporateInvoiceData?.emailCorporation}
                  setValue={(e) => updateValue(e.target)}
                  name="emailCorporation"
                  label="Email"
                  placeholder="example@example.com"
                />
              </div>
              <div className="box-row">
                <Input
                  value={remask(corporation?.corporateInvoiceData?.cnpj, ["99.999.999/9999-99"]) || corporation?.corporateInvoiceData?.cnpj}
                  setValue={(e) => updateValue(e.target)}
                  name="cnpj"
                  label="CNPJ"
                  placeholder="CNPJ"
                />
                <Input
                  value={remask(corporation?.corporateInvoiceData?.zipCode, ["99.999-999"]) || corporation?.corporateInvoiceData?.zipCode}
                  setValue={(e) => {
                    updateValue(e.target);
                    if (e.target.value?.length === 10) getCEPAndUpdateValue(e.target.value);
                  }}
                  name="zipCode"
                  label="CEP"
                  placeholder="CEP"
                />
              </div>
              <div className="box-row">
                <Input
                  className="corporation-street"
                  value={corporation?.corporateInvoiceData?.street}
                  setValue={(e) => updateValue(e.target)}
                  name="street"
                  label="Rua"
                  placeholder="Rua"
                />
                <div className="corporation-city-state box-row">
                  <Input
                    value={corporation?.corporateInvoiceData?.city}
                    setValue={(e) => updateValue(e.target)}
                    name="city"
                    label="Cidade"
                    placeholder="Cidade"
                  />
                  <Input
                    value={corporation?.corporateInvoiceData?.state}
                    setValue={(e) => updateValue(e.target)}
                    name="state"
                    label="Estado"
                    placeholder="Estado"
                  />
                </div>
              </div>
            </div>
            <div className="corporation-button-box flex">
              <button type="submit" className="btn bg-primary">
                Salvar
              </button>
            </div>
          </div>
        </form>
      </Spinner>
    </>
  );
}
